import { render } from "./AppHeaderBurger.vue?vue&type=template&id=fa70a862&scoped=true"
import script from "./AppHeaderBurger.vue?vue&type=script&lang=js"
export * from "./AppHeaderBurger.vue?vue&type=script&lang=js"

import "./AppHeaderBurger.vue?vue&type=style&index=0&id=fa70a862&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa70a862"]])

export default __exports__